import { useEffect, useRef, useState } from 'react'
import { ReactComponent as Pin } from './mapPin.svg';
import styles from './AnimatedMap.module.css'

export default function AnimatedMap({mapWidth,mapHeight,resetWidth}){

    const outerContainer = useRef();

    const [oCWidth,setOCWidth] = useState(0);
    const [oCHeight,setOCHeight] = useState(0);

    const getSize = () => {
        setOCWidth(outerContainer.current.getBoundingClientRect().right-outerContainer.current.getBoundingClientRect().left);
        setOCHeight(outerContainer.current.getBoundingClientRect().bottom-outerContainer.current.getBoundingClientRect().top);
    }

    useEffect(() => {
        if(outerContainer.current){
            getSize();
        }
    },[outerContainer.current,resetWidth]);

    return (
        <div style={{width: `${mapWidth? mapWidth : ''}`,height: `${mapHeight? mapHeight : `${oCHeight}px`}`}} className={styles.outerContainer}>
            <img className={styles.map} style={{margin: '0', width: `${mapWidth? mapWidth : 'unset'}`, height: `${mapHeight? mapHeight : 'unset'}`}} ref={outerContainer} src={'./../imgs/map.svg'}/>
            <div style={{margin: '0', bottom: `${oCHeight*0.44}px`, left: `${oCWidth*0.335}px`}} className={`${styles.pin} ${styles.uk}`}>
                <Pin src={'./../imgs/mapPin.svg'}/>
            </div>
            <div style={{margin: '0', bottom: `${oCHeight*0.22}px`, left: `${oCWidth*0.31}px`}} className={`${styles.pin} ${styles.spain}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.2}px`, left: `${oCWidth*0.27}px`}} className={`${styles.pin} ${styles.portugal}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.33}px`, left: `${oCWidth*0.365}px`}} className={`${styles.pin} ${styles.france}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.41}px`, left: `${oCWidth*0.38}px`}} className={`${styles.pin} ${styles.belgium}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.45}px`, left: `${oCWidth*0.395}px`}} className={`${styles.pin} ${styles.netherlands}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.395}px`, left: `${oCWidth*0.397}px`}} className={`${styles.pin} ${styles.luxembourg}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.34}px`, left: `${oCWidth*0.41}px`}} className={`${styles.pin} ${styles.switzerland}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.348}px`, left: `${oCWidth*0.43}px`}} className={`${styles.pin} ${styles.liechtenstein}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.26}px`, left: `${oCWidth*0.46}px`}} className={`${styles.pin} ${styles.italy}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.325}px`, left: `${oCWidth*0.473}px`}} className={`${styles.pin} ${styles.slovenia}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.315}px`, left: `${oCWidth*0.495}px`}} className={`${styles.pin} ${styles.croatia}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.42}px`, left: `${oCWidth*0.43}px`}} className={`${styles.pin} ${styles.germany}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.39}px`, left: `${oCWidth*0.48}px`}} className={`${styles.pin} ${styles.czechia}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.43}px`, left: `${oCWidth*0.51}px`}} className={`${styles.pin} ${styles.poland}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.375}px`, left: `${oCWidth*0.515}px`}} className={`${styles.pin} ${styles.slovakia}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.345}px`, left: `${oCWidth*0.528}px`}} className={`${styles.pin} ${styles.hungary}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.28}px`, left: `${oCWidth*0.51}px`}} className={`${styles.pin} ${styles.bosnia}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.29}px`, left: `${oCWidth*0.535}px`}} className={`${styles.pin} ${styles.serbia}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.245}px`, left: `${oCWidth*0.545}px`}} className={`${styles.pin} ${styles.nMacedonia}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.205}px`, left: `${oCWidth*0.555}px`}} className={`${styles.pin} ${styles.greece}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.32}px`, left: `${oCWidth*0.57}px`}} className={`${styles.pin} ${styles.romania}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>

            <div style={{margin: '0', bottom: `${oCHeight*0.265}px`, left: `${oCWidth*0.575}px`}} className={`${styles.pin} ${styles.bulgaria}`}>
                <Pin src={'./../imgs/mapPin.svg'} />
            </div>
        </div>
    )
}

{/* <div style={{margin: '0', bottom: `${oCHeight*0.44}px`, left: `${oCWidth*0.335}px`}} className={`${styles.pin} ${styles.uk}`}>
        <Pin src={'./../imgs/mapPin.svg'}/>
    </div>
    <img style={{margin: '0', bottom: `${oCHeight*0.22}px`, left: `${oCWidth*0.31}px`}} className={`${styles.pin} ${styles.spain}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.2}px`, left: `${oCWidth*0.27}px`}} className={`${styles.pin} ${styles.portugal}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.33}px`, left: `${oCWidth*0.365}px`}} className={`${styles.pin} ${styles.france}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.41}px`, left: `${oCWidth*0.38}px`}} className={`${styles.pin} ${styles.belgium}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.45}px`, left: `${oCWidth*0.395}px`}} className={`${styles.pin} ${styles.netherlands}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.395}px`, left: `${oCWidth*0.397}px`}} className={`${styles.pin} ${styles.luxembourg}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.34}px`, left: `${oCWidth*0.41}px`}} className={`${styles.pin} ${styles.switzerland}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.348}px`, left: `${oCWidth*0.43}px`}} className={`${styles.pin} ${styles.liechtenstein}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.26}px`, left: `${oCWidth*0.46}px`}} className={`${styles.pin} ${styles.italy}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.325}px`, left: `${oCWidth*0.473}px`}} className={`${styles.pin} ${styles.slovenia}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.315}px`, left: `${oCWidth*0.495}px`}} className={`${styles.pin} ${styles.croatia}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.42}px`, left: `${oCWidth*0.43}px`}} className={`${styles.pin} ${styles.germany}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.39}px`, left: `${oCWidth*0.48}px`}} className={`${styles.pin} ${styles.czechia}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.43}px`, left: `${oCWidth*0.51}px`}} className={`${styles.pin} ${styles.poland}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.375}px`, left: `${oCWidth*0.515}px`}} className={`${styles.pin} ${styles.slovakia}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.345}px`, left: `${oCWidth*0.528}px`}} className={`${styles.pin} ${styles.hungary}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.28}px`, left: `${oCWidth*0.51}px`}} className={`${styles.pin} ${styles.bosnia}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.29}px`, left: `${oCWidth*0.535}px`}} className={`${styles.pin} ${styles.serbia}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.245}px`, left: `${oCWidth*0.545}px`}} className={`${styles.pin} ${styles.nMacedonia}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.205}px`, left: `${oCWidth*0.555}px`}} className={`${styles.pin} ${styles.greece}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.32}px`, left: `${oCWidth*0.57}px`}} className={`${styles.pin} ${styles.romania}`} src={'./../imgs/mapPin.svg'}/>
    <img style={{margin: '0', bottom: `${oCHeight*0.265}px`, left: `${oCWidth*0.575}px`}} className={`${styles.pin} ${styles.bulgaria}`} src={'./../imgs/mapPin.svg'}/> */}